import {Record, OrderedMap} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

const OrganizationOccupancyData = new Record({
    average: OrderedMap(),
});

export const fetchOccupancyData = (organizationId, refresh, year) => {
    /*
        For some ARCANE reason the backend will return data starting from the month just before what was requested
        Furthermore, we always get one more month that noMonths is set to (I expect noMonths is actually "extra" months)
     */
    const month = `${year}-02`;
    return RESTClient.dispatchAuthenticatedRequestObservable({
        endpoint: `v2/sessions/organization-reports/occupancy${refresh ? '/refresh' : ''}`,
        data: {
            organizationId,
            month,
            groupBy: 'room',
            format: 'json',
            noMonths: 11,
        },
        method: refresh ? 'POST' : 'GET',
    }).map(
        data =>
            new OrganizationOccupancyData({
                ...data,
                average: OrderedMap(data.average).sortBy((_, key) => key),
            }),
    );
};

const OrganizationLeaversAndJoinersData = new Record({
    joiners: OrderedMap(),
    leavers: OrderedMap(),
});

export const fetchLeaversAndJoiners = (organizationId, year) => {
    return RESTClient.getAuthenticatedObservable(`v2/children/leavers-and-joiners/${organizationId}/${year}`).map(
        data =>
            new OrganizationLeaversAndJoinersData({
                joiners: OrderedMap(data.joiners).sortBy((_, key) => key),
                leavers: OrderedMap(data.leavers).sortBy((_, key) => key),
            }),
    );
};

const OrganizationEnrolledData = new Record({
    enrolled: OrderedMap(),
});

export const fetchEnrolledData = (organizationId, year) => {
    return RESTClient.getAuthenticatedObservable(`v2/children/enrolled/${organizationId}/${year}`).map(
        data =>
            new OrganizationEnrolledData({
                enrolled: OrderedMap(data.enrolled).sortBy((_, key) => key),
            }),
    );
};

const OrganizationRegisteredEmployees = new Record({
    registered: OrderedMap(),
});

export const fetchRegisteredEmployees = (organizationId, year) => {
    return RESTClient.getAuthenticatedObservable(`v2/employees/registered/${organizationId}/${year}`).map(
        data =>
            new OrganizationRegisteredEmployees({
                registered: OrderedMap(data.registered).sortBy((_, key) => key),
            }),
    );
};

const OrganizationEmployeeSickDays = new Record({
    sickDays: OrderedMap(),
});

export const fetchEmployeeSickDays = (organizationId, year) => {
    return RESTClient.getAuthenticatedObservable(`v2/employees/sick-days/${organizationId}/${year}`).map(
        data =>
            new OrganizationEmployeeSickDays({
                sickDays: OrderedMap(data.sickDays).sortBy((_, key) => key),
            }),
    );
};
